// material
import { Container } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

// components
import PageHeader from '../components/smallComponents/PageHeader';
import Page from '../components/Page';
import Projects from '../components/Projects';

export default function ProjectsOfCustomer() {
  const [searchParams, setSearchParams] = useSearchParams();
  const customerId = searchParams.get('customerId');

  return (
    <Page title="Customer Projects">
      <Container maxWidth="xl">
        <PageHeader title="Customer Projects" />
        <Projects customerId={customerId} />
      </Container>
    </Page>
  );
}
